// LoadingSpinner.js
import React from "react";
import bg from "../assets/bg1.gif"

const Loading = () => (
  <div className="flex flex-col items-center justify-center h-screen bg-white">
    {/* <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent border-dashed rounded-full animate-spin"></div> */}
    <img
      className="mt-6 opacity-100 transition-opacity duration-500 max-w-full h-auto"
      src={bg}
      alt="Loading..."
      loading="lazy"
    />  
  </div>
);

export default Loading;
